import React from "react";
import { useLang } from "@/i18n";
import Reveal from "@/components/Reveal";
import { Sparkles, HandHeart, Compass, ShieldCheck } from "lucide-react";

const icons = [Sparkles, HandHeart, Compass, ShieldCheck];

export default function TrustSection() {
  const { t } = useLang();
  const items = t("trust.items");
  return (
    <section data-testid="trust-section" className="max-w-[1440px] mx-auto px-6 md:px-12 py-24 md:py-32">
      <div className="grid md:grid-cols-12 gap-12 md:gap-16 items-end mb-14 md:mb-20">
        <div className="md:col-span-5">
          <p className="eyebrow mb-4">{t("trust.kicker")}</p>
          <h2 className="font-serif-hc text-4xl md:text-5xl lg:text-[56px] leading-[1.05] text-[#F5F2EA] font-light">
            {t("trust.title")}
          </h2>
        </div>
        <div className="md:col-span-6 md:col-start-7">
          <div className="h-px w-full bg-[#1E2B25]" />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-6">
        {items.map((it, i) => {
          const Icon = icons[i];
          return (
            <Reveal key={i} delay={i * 90} className="flex flex-col gap-5">
              <div className="w-12 h-12 border border-[#C4A661]/40 flex items-center justify-center text-[#C4A661]">
                <Icon size={20} strokeWidth={1.4} />
              </div>
              <h3 className="font-serif-hc text-2xl text-[#F5F2EA] leading-tight">{typeof it.t === "string" ? it.t : it.t.es}</h3>
              <p className="text-[15px] text-[#A3A095] leading-relaxed">{typeof it.d === "string" ? it.d : it.d.es}</p>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
